/* HeroCardList.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0u2WMmrU95%7Bcontainer-type%3Ainline-size%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3n40gW4YzI%7Bcontainer-name%3Abrowse-hero-card-list%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2mHwu8kG2W%7Bgap%3Avar(--ds-space-250%2C20px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbgBM8%7Bdisplay%3Agrid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2iEGP28wUV%7Bgrid-template-columns%3Aminmax(0%2C1fr)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40container%20browse-hero-card-list%20(min-width%3A%20900px)%7B._37BFTJ7s7Z%7Bgrid-template-columns%3Arepeat(2%2Cminmax(0%2C1fr))%7D%7D");
import React from 'react';
import Heading from '@atlaskit/heading/heading';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';
const styles = {
  container: "_0u2WMmrU95 _3n40gW4YzI",
  grid: "_2mHwu8kG2W _3iDTPbgBM8 _2iEGP28wUV _37BFTJ7s7Z"
};
export type HeroCardListProps = {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
  testId?: string;
};
export const HeroCardList = ({
  children,
  title,
  subtitle,
  testId
}: HeroCardListProps): React.JSX.Element => <Stack space="space.200" xcss={styles.container} testId={testId}>
		{(title || subtitle) && <Stack space="space.050">
				{title && <Heading size="small" as="h2">
						{title}
					</Heading>}
				{subtitle && <Text as="p" color="color.text.subtlest">
						{subtitle}
					</Text>}
			</Stack>}
		<Box xcss={styles.grid} testId={testId ? `${testId}--items` : undefined}>
			{children}
		</Box>
	</Stack>;